import { render, staticRenderFns } from "./details.vue?vue&type=template&id=344e4e46&scoped=true&"
import script from "./details.vue?vue&type=script&lang=js&"
export * from "./details.vue?vue&type=script&lang=js&"
import style0 from "./details.vue?vue&type=style&index=0&id=344e4e46&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344e4e46",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Comment: require('/var/jenkins_home/workspace/prod-web-xfans/components/comment.vue').default})
